
import React from 'react';

const Loader = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      {/* <div className="line-2-vertical"></div> */}
    </div>
  );
};

export default Loader;
